module.exports = __webpack_public_path__ + "img/category-sport.2b466bfb.png";